import { API_URL } from '@/config';
import axios from 'axios';
import Cookies from 'js-cookie';

export class BaseApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_URL || 'https://postscryptv2.gitwork.tech/api/',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    // Add request interceptor for auth token - use cookies instead of localStorage
    this.api.interceptors.request.use((config) => {
      const token = Cookies.get('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }
} 